import { Flex, Menu, Text } from "@mantine/core";
import {
  IconSquare,
  IconSquareCheckFilled,
} from "@tabler/icons-react";

export function ToggleButton({
  id,
  parentId,
  label,
  color,
  onClick,
  isActive = false,
  disabled = false,
}: {
  id: string;
  parentId?: string;
  label: string;
  color?: string;
  onClick: (actionId: string, parentId?: string) => void;
  isActive?: boolean;
  disabled?: boolean;
}) {
  const menuItemColor = disabled
    ? "var(--mantine-color-gray-6)"
    : "var(--mantine-color-dark-6)";

  function onClickHandler() {
    if (disabled) return;
    onClick(id, parentId);
  }

  return (
    <Menu.Item
      onClick={onClickHandler}
      disabled={disabled}
      opacity={disabled ? 0.6 : 1}
      color="var(--mantine-color-gray-2)"
      c={menuItemColor}
    >
      <Flex
        w="100%"
        direction="row"
        align="center"
        justify="flex-start"
        gap="xs"
      >
        {isActive ? (
          <IconSquareCheckFilled
            size={20}
            color={color ?? "var(--mantine-color-eu_flag-filled)"}
          />
        ) : (
          <IconSquare
            stroke={1.2}
            size={20}
            color="var(--mantine-color-dark-6)"
          />
        )}
        <Text flex={1} fw={400} fz={15} c="var(--mantine-color-dark-6)">
          {label}
        </Text>
      </Flex>
    </Menu.Item>
  );
}
